import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import EcosystemSelect from "./pages/EcosystemSelect";
import ChatPage from "./pages/ChatPage";
import ActionPage from "./pages/ActionPage";
import StoryPage from "./pages/StoryPage";
import BackgroundAudio from "./components/BackgroundAudio"; // ✅ Import audio

function App() {
  return (
    <Router>
      <div>
        <BackgroundAudio /> {/* ✅ Globally available background sound */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/select" element={<EcosystemSelect />} />
          <Route path="/chat/:eco" element={<ChatPage />} />
          <Route path="/action" element={<ActionPage />} />
          <Route path="/stories" element={<StoryPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

